import clsx from "clsx";

interface InfoProps {
  label: string;
  value: string;
  className?: string;
}

export default function Info(props: InfoProps): JSX.Element {
  const { label, value } = props;
  const { className } = props;

  return (
    <div className={clsx("flex flex-col", { [className]: className })}>
      <span className="overline mb-[10px]">{label}</span>
      <span className="text-4xl font-semibold">{value}</span>
    </div>
  );
}
